<div class="mini-compare-bar-container" [ngClass]="{ collapsed: !isExpanded }">
	<div class="mini-compare-bar-mobile">
		<div class="text-align-right">
			<dz-icon type="times" (click)="updateSelectedModels($event, selectedModelsToCompare[0])"></dz-icon>
		</div>
		<div class="text-align-center mobile-message-container">
			<span class="text-16" dcrHTMLKey="SWITCH_TO_DESKTOP_TABLET_LABEL">Please switch to a tablet or desktop device to compare</span>
		</div>
		<div class="text-align-center sign-in-cta-container">
			<button dz-button dcrHTMLKey="MOBILE_LOGIN_CTA_LABEL" (click)="signIn()">Sign In</button>
		</div>
	</div>
	<div class="mini-compare-bar dz-grid">
		<ng-container *ngIf="isExpanded; else isCollapsed">
			<div class="dz-flex dz-justify-content-between dz-align-items-center">
				<dz-microaction icon="chevron-up" (menuItemClick)="isExpanded = !isExpanded" clickable>
					<span dcrHTMLKey="HIDE_SELECTED_LABEL">Hide Selected Models</span>
				</dz-microaction>
				<dz-microaction class="dz-hidden dz-block-lg" icon="times-circle" (menuItemClick)="clearAllSelections()" clickable
					><span dcrHTMLKey="CLEAR_ALL_LABEL">Clear All</span></dz-microaction
				>
				<ng-template [ngTemplateOutlet]="compareDetails" [ngTemplateOutletContext]="{ textClass: 'dz-hidden-lg', buttonClass: 'dz-hidden-lg' }"></ng-template>
			</div>
			<section class="margin-top-20 dz-flex align-items-center justify-content-between">
				<section class="portfolio-card-container">
					<section class="dz-row min-height">
						<dz-card class="dz-col-8" [isSelected]="true" *ngFor="let card of selectedModelsToCompare">
							<dz-icon dzCardSelected type="times" (click)="updateSelectedModels($event, card)" clickable></dz-icon>
							<dz-card-title align="left" class="model-card-title">{{ card?.familyName }}</dz-card-title>
							<div dzCardContent align="left">
								<mb-risk-profile-indicator [riskGroupKey]="card?.riskGroupKey || card?.riskProfile"></mb-risk-profile-indicator>
								<span class="margin-left-8">{{ card?.modelShortName }}</span>
							</div>
						</dz-card>

						<me-mini-compare-bar-skeleton
							[ngClass]="{
								'dz-col-16': selectedModelsToCompare.length === 1,
								'dz-col-8': selectedModelsToCompare.length === 2
							}"
							[modelsCount]="selectedModelsToCompare.length"
							*ngIf="selectedModelsToCompare.length < 3"
						></me-mini-compare-bar-skeleton>
					</section>
				</section>
				<section class="compare-button-container dz-hidden dz-inline-block-lg">
					<ng-template [ngTemplateOutlet]="compareDetails" [ngTemplateOutletContext]="{ textClass: 'margin-bottom-16' }"></ng-template>
				</section>
			</section>
		</ng-container>
	</div>

	<ng-template #isCollapsed>
		<dz-microaction icon="chevron-down" (menuItemClick)="isExpanded = !isExpanded" clickable>
			<span dcrHTMLKey="SHOW_SELECTED_LABEL">Show Selected Models</span>
		</dz-microaction>
	</ng-template>
</div>

<ng-template #compareDetails let-buttonClass="buttonClass" let-textClass="textClass">
	<div class="text-align-right text-16 text-class padding-right-object-4-md" [class]="textClass">
		<span class="text-16-bold">{{ selectedModelsToCompare.length }}</span>
		<span dcrHTMLKey="OUT_OF_LABEL">out of</span>
		<span class="text-16-bold">{{ noOfModels }}</span>
		<span dcrHTMLKey="SELECTED_LABEL">Selected</span>
	</div>
	<button [class]="buttonClass" data-cy="compare-btn" dz-button [disabled]="selectedModelsToCompare?.length === 1" dcrHTMLKey="GO_TO_COMPARE_LABEL" (click)="onCompareModels()">
		Go to Compare
	</button>
</ng-template>
